import vue from "vue";
import { initialState } from "./initialState";
export default {
    SET_INSURANCES: (state, insurances) => {
        state.insurances = insurances;
    },
    RESET_MODULE (state) { // To reset the entire module
        // Object.assign(state, JSON.parse(JSON.stringify(initialState)))
        Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))))
    }
}